// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* eslint:disable */
export const VERSION = {
    "version": "4.1.0",
    "short": "f8b477a",
    "branch": "Detached: f8b477a267f556b57e24bdcab1420e78ee0328b5",
    "date": "2026-3-30"
};
/* eslint:enable */
